<script>
  import { navigate } from "svelte-routing";
  import { Icon } from "t2c-components";

  export let lawcaseId;
  export let id;
  export let name;

  const handleNavigate = () => {
    const route = `/lawcase/${lawcaseId}/folder/${id}`;
    navigate(route);
  };
</script>

<div class="tile" on:click={handleNavigate}>
  <div class="tile-link">
    <div class="container">
      <div class="icon">
        <Icon big icon="folder" fill="currentColor" />
      </div>
      <div class="title">
        <h2>{name}</h2>
      </div>
    </div>
  </div>
</div>

<style>
  :global(.tile-link) {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    z-index: 2;
  }

  .tile {
    position: relative;
    display: block;
    height: 0;
    padding-bottom: 100%;
    overflow: hidden;
    transition: all 0.2s ease-in-out;
  }

  .container:hover {
    color: white;
    background-color: #40798c;
    transition: all 0.2s ease-in-out;
  }

  .container:hover * {
    background-color: rgba(255, 255, 255, 0);
    transition: background-color 0.2s ease-in-out;
  }

  .container {
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid #1f363d;
    cursor: pointer;
  }

  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 12px;
    height: 50%;
    flex: 0 0 auto;
  }

  h2 {
    font-weight: 300;
    font-size: 22px;
    /* word-wrap: break-word; */
    word-break: break-all;
    line-height: 26px;
    background-color: rgba(255, 255, 255, 0.5);
  }

  .icon {
    margin: 48px auto 0;
  }
</style>
